import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import type { CompletionsSummary } from '../../_types/training';

export const getCompletionsSummary = async (
  orgId: string,
  signal?: AbortSignal,
  onError?: (errors: ServerErrorResponse) => void
): Promise<CompletionsSummary> => {
  const url = `${baseApiUrl()}/activity-center/v1/organizations/${orgId}/training/users-completions-summary`;

  try {
    const summary = await fetcher({
      method: 'get',
      url,
      options: { signal },
    });
    return summary as CompletionsSummary;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    console.warn('error retrieving completions summary', error);
    throw error;
  }
};

export default function useCompletionsSummary(
  orgId: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<CompletionsSummary, Error>(
    ['completions_summary', orgId],
    async ({ signal }): Promise<CompletionsSummary> => {
      return getCompletionsSummary(orgId, signal, onError);
    },
    {
      ...options,
      enabled: !!orgId,
      keepPreviousData: true,
      refetchOnWindowFocus: true,
      refetchInterval: 1000 * 60 * 2, // 2 minutes
    }
  );
}
